import {useMemo} from 'react';
import {FOEDUS_ROLE} from '../domain/constants';

export const useNewOrganOfferFilters = (
	{
		loggedUserPrimaryFoedusRole,
		loggedUserCountry,
		nationalBodyCoreCodebook,
		countryCoreCodebook,
		newOrganOfferFormData
	}
) => {
	const organizationFixedFilter = useMemo(() => {
		const getFilter = (types, id) => ({
			organizationTypes: types ? [types] : [],
			parentId: id
		});

		if (loggedUserPrimaryFoedusRole === FOEDUS_ROLE.COUNTRY_MANAGER) {
			return getFilter(nationalBodyCoreCodebook, loggedUserCountry?.id);
		}

		if (loggedUserPrimaryFoedusRole === FOEDUS_ROLE.ADMIN) {
			return getFilter(nationalBodyCoreCodebook, newOrganOfferFormData?.values?.COUNTRY?.item?.id);
		}

		return {};
	}, [loggedUserPrimaryFoedusRole, nationalBodyCoreCodebook, loggedUserCountry, newOrganOfferFormData]);

	const countryFixedFilter = useMemo(() => {
		return {
			organizationTypes: countryCoreCodebook ? [countryCoreCodebook] : []
		};
	}, [countryCoreCodebook]);

	return {
		organizationFixedFilter,
		countryFixedFilter
	};
};
